import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { ProductListStore } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import dataAids from '../../../constants/dataAids';

const styles = {
  banner: {},
  background: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  common: {
    'display': 'flex',
    'flexDirection': 'column',
    'alignItems': 'center',
    'justifyContent': 'center',
    'textAlign': 'center',
    'minHeight': '180px',
    '@md': {
      minHeight: '220px'
    }
  },
  section: {
    width: '100%'
  },
  description: {
    maxWidth: '80%'
  }
};

class CoverImage extends React.Component {
  constructor() {
    super(...arguments);

    this.onStoreChange = this.onStoreChange.bind(this);
    this.state = this.getStoreState();
  }

  getStoreState() {
    const {
      fetching: fetchingProducts
    } = ProductListStore.getState();

    return {
      fetchingProducts
    };
  }

  componentDidMount() {
    ProductListStore.addListener('change', this.onStoreChange);
  }

  componentWillUnmount() {
    ProductListStore.removeListener('change', this.onStoreChange);
  }

  onStoreChange() {
    this.setState(this.getStoreState());
  }


  render() {
    const {
      categoryDetails
    } = this.props;

    const {
      fetchingProducts
    } = this.state;

    const { Text, Heading, Container } = UX2.Element;
    const { Section, Group } = UX2.Group;
    const { Widget, Background } = UX2.Component;

    const overlay = 'rgba(0, 0, 0, 0.2)'; // Gray tinting over the cover image

    if (fetchingProducts) {
      styles.banner.visibility = 'hidden';
    } else {
      styles.banner.visibility = 'visible';
    }

    const sectionProps = {
      category: 'accent',
      section: 'overlay',
      backgroundColor: overlay
    };

    const imageParams = 'rs=w:{width},h:{height},cg:true,m/cr=w:{width},h:{height}';
    const imageUrl = categoryDetails.image.replace(/rs=w:\d+,h:\d+/, imageParams);

    return (
      <Widget.Banner style={ styles.banner } { ...this.props }>
        <Background
          backgroundImage={ imageUrl }
          data-aid={ dataAids.COVER_IMAGE_BACKGROUND }
          style={ styles.background }
        >
          <Section.Banner data-aid={ dataAids.COVER_IMAGE_BANNER }
            { ...sectionProps }
            style={ styles.section }
          >
            <Container>
              <Group style={ styles.common }>
                <Heading.Major
                  data-aid={ dataAids.COVER_IMAGE_HEADING }
                  children={ categoryDetails.name }
                />
                {categoryDetails.description &&
                  <Text
                    style={ styles.description }
                    richtext
                    font={ 'alternate' }
                    children={ categoryDetails.description }
                  />
                }
              </Group>
            </Container>
          </Section.Banner>
        </Background>
      </Widget.Banner>
    );
  }
}

CoverImage.propTypes = {
  categoryDetails: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.string.isRequired
  })
};

export default CoverImage;
